import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading:false,
    user:{},
    permissions:{},
    baseUrl:'https://api.aatcart.com/api/admin',
  },
  getters: {
  },
  mutations: {
    isLogin (state,data) {
      localStorage.token = data.token;
      localStorage.refresh = data.refresh_token;
    },
    me(state,res){
      console.log('-----------here in me------------')
      state.user=res.user
      localStorage.setItem('permissions', JSON.stringify(res.permissions));

    },
    logout(state) {
      localStorage.removeItem('token');
      localStorage.removeItem('refresh');
      state.user={};
      location.href = "/sign-in";
    },
  },
  actions: {
  },
  modules: {
  }
})
